import { MinusSmallIcon, PlusSmallIcon } from "@heroicons/react/24/solid";
import { Text } from "north.js";
import React from "react";
import styled from "styled-components";
interface CounterProps {
  value: number;
  min?: number;
  max?: number;
  disabled?: boolean;
  onChange: (newValue: number) => void;
}
const Counter: React.FC<CounterProps> = ({
  value,
  min = 0,
  max = Infinity,
  disabled = false,
  onChange,
}) => {
  const decrement = () => {
    if (value > min && !disabled) onChange(value - 1);
  };

  const increment = () => {
    if (value < max && !disabled) onChange(value + 1);
  };

  return (
    <Wrapper disabled={disabled}>
      <AdjustIcon disabled={disabled}>
        <MinusSmallIcon width={16} onClick={decrement} />
      </AdjustIcon>
      <Text>{value}</Text>
      <AdjustIcon disabled={disabled}>
        <PlusSmallIcon width={16} onClick={increment} />
      </AdjustIcon>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ disabled: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 8px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.globalConstants.color.borderGray};
  color: ${({ theme, disabled }) =>
    disabled
      ? theme.globalConstants.color.textTertiary
      : theme.globalConstants.color.textSecondary};
  cursor: ${({ disabled }) => disabled && "not-allowed"} !important;
  background-color: ${({ theme, disabled }) =>
    disabled
      ? theme.globalConstants.color.backgroundLight
      : theme.globalConstants.color.backgroundWhite} !important;
`;

const AdjustIcon = styled.div<{ disabled: boolean }>`
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  transition: opacity 0.2s ease;
`;
export default Counter;
